<footer id="footer">
  <div id="text" [innerHtml]="settingsModel().FooterText"></div>
  <div id="divider"></div>
  <div id="footer-phone">
    <p>Event AS</p>
    <p>Lommedalsveien 189A, 1353 Bærums Verk</p>
    <p>+47 67 13 43 00</p>
    <p><a href="mailto:hello@event.no">hello&#64;event.no</a></p>
  </div>
  <div id="icons">
    <div id="social-media">
      <a
        href="https://www.instagram.com/eventno"
        aria-label="Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55">
          <circle cx="27.5" cy="27.5" r="27" stroke="#FFF" fill="none" />
          <path
            fill="#FFF"
            d="M35.2 15H19.8a4.8 4.8 0 00-4.8 4.8v15.4c0 2.6 2.2 4.8 4.8 4.8h15.4c2.6 0 4.8-2.2 4.8-4.8V19.8c0-2.6-2.2-4.8-4.8-4.8zm1.4 2.9h.5V22H33V18h3.7zm-12.7 7a4.4 4.4 0 117.2 5.2 4.4 4.4 0 01-7.2-5.2zm13.7 10.3c0 1.3-1.1 2.4-2.4 2.4H19.8c-1.3 0-2.4-1.1-2.4-2.4V24.9h3.8c-.4.8-.5 1.7-.5 2.6a6.8 6.8 0 1013.1-2.6h3.8v10.3z"
          />
        </svg>
      </a>
      <a
        href="https://www.facebook.com/Eventno-116752655022965"
        aria-label="Facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55">
          <circle cx="27.5" cy="27.5" r="27" stroke="#FFF" fill="none" />
          <path
            fill="#FFF"
            d="M29.3 44h-6.2V29.5H20v-5h3.1v-3c0-4 1.8-6.5 6.7-6.5H34v5h-2.6c-2 0-2 .7-2 2v2.5H34l-.6 5h-4V44z"
          />
        </svg>
      </a>
      <a
        href="https://www.linkedin.com/company/event-no/"
        aria-label="Linkedin"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 55">
          <circle cx="27.5" cy="27.5" r="27" stroke="#FFF" fill="none" />
          <path
            fill="#FFF"
            d="M15.6 23h4.9v17h-4.9V23zM18 21c-1.8 0-2.9-1.3-2.9-3 0-1.6 1.2-2.9 3-2.9s2.9 1.3 3 3c0 1.6-1.2 2.9-3 2.9zM40 40h-5.5v-8.8c0-2.3-.9-3.9-2.8-3.9-1.4 0-2.3 1.1-2.6 2.1-.2.4-.1.9-.1 1.4V40h-5.5V23H29v2.7c.3-1.2 2-2.8 4.8-2.8 3.5 0 6.2 2.4 6.2 7.7V40z"
          />
        </svg>
      </a>
    </div>
    <div id="credentials">
      <img
        src="/assets/images/miljofyrtarn-logga.png"
        loading="lazy"
        title="Miljøfyrtårn"
      />
      <img
        src="/assets/images/rgf.png"
        loading="lazy"
        title="Reisegarantifondet"
      />
    </div>
  </div>
</footer>
<div id="privacy">
  <a href="/cookie">Cookies</a>
  <a href="/personvernerklaering">Persondatapolitikk</a>
</div>
<div id="copyright">
  <p>Copyright © 2011 - {{ currentYear }} // Event.no</p>
</div>
@if (!cookieSettingsShow()) {
  <div class="cookie-settings" (click)="openCookieSettings()">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="#fff"
        d="M266.9 31.9C158.6 30.5 30.3 148.3 32 256c1.8 113.4 142.9 231.4 256 224 95.5-6.2 189.9-119.7 189.8-215.4C477.7 161.1 375.4 36.9 272 32l-5.1-.1zm24.8 21c1 0 1.9.1 2.9.3 16.7 4.1 27.3 37.4 15 49.5-12 11.8-44 .6-48-15.7-3.5-14.4 15.1-34.8 30.1-34.2zm-156.3 78.5c1.4 0 2.7.2 4 .5 17.9 4.1 31.6 34.3 22.5 50.3-7.5 13.1-30.6 9.8-45 5.2-8.9-2.8-21-9.3-21-18.7.3-17.2 20.6-36.9 38.2-37.3h1.3zm238.7 69.5h1.2c12.1.2 24.7 14.9 25 27 .3 10.6-10.4 22.9-21 24-11.5 1.2-26.1-9.5-27.7-21-1.7-12.4 10-29.2 22.5-30zm-141 105.7c15.4 0 26 22.1 27 37.5.7 11.9-5.4 29.7-17.2 31.5-16.1 2.5-33.8-17.6-35.3-33.8-1.3-14.4 11-35.2 25.5-35.2zm188.6 1.1c1.2 0 2.2.1 3.3.4 11.7 3.2 17.8 26.9 9 35.2-8.5 8.1-30.9.9-33.7-10.5-2.5-10.2 10.6-24.8 21.4-25.1zm-269.6 19.9c19.2-.5 36 30.2 30.8 48.7-3.7 13.1-23.1 18.2-36.8 18-9-.1-21.4-4-24-12.7-5.9-19.7 9.4-53.4 30-54zm166.2 87.6 1 .1c11.3 1.1 21.2 17.4 18.8 28.5-2.2 10.1-16.2 18.7-26.3 16.5-8.8-1.9-15.8-13.5-14.9-22.5 1-10.2 11.2-22.8 21.4-22.6z"
      />
    </svg>
  </div>
}
